<!--
Renders a hidden model to display when text has been copied to the clip board.
Usage: <CopyComplete item="text" />
@author bmk11u
-->
<template>
  <div>
    <ModalPopup id="copyComplete" title="Copy Complete">
      The {{ item }} has been copied to your clip board.
      <div class="btn-group w-100 pt-1" role="group" aria-label="Form buttons">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">OK</button>
      </div>
    </ModalPopup>
  </div>
</template>

<script>
import ModalPopup from '@/components/ModalPopup.vue'

export default {
  name: 'CopyComplete',
  props: ['item'],
  components: {
    ModalPopup
  }
}
</script>
